// src/config/env.ts

type NodeEnv = "development" | "production" | "test";

const parsePort = (
  value: string | undefined,
  fallback: number
): number => {
  const port = Number(value);

  return Number.isInteger(port) && port > 0 && port <= 65535
    ? port
    : fallback;
};

export const env = {
  NODE_ENV: (process.env.NODE_ENV as NodeEnv) || "development",
  PORT: parsePort(process.env.PORT, 3080),
  APP_NAME: process.env.REACT_APP_NAME || "One Place Deal",
  APP_URL: process.env.REACT_APP_URL || "http://localhost:3080",
  IMAGE_BASE_URL:
    "https://api-7xq9k2m4v8.oneplacedeal.com/storage",
  IMAGE_BASE_URL_SANS_STORAGE:
    "https://api-7xq9k2m4v8.oneplacedeal.com",
  PRODUCT_WHATSAPP:
    process.env.REACT_APP_PRODUCT_WHATSAPP || "",

  PROFILE_TELEGRAM:
    process.env.REACT_APP_PROFILE_TELEGRAM || "",
  PRODUCT_TELEGRAM:
    process.env.REACT_APP_PRODUCT_TELEGRAM || "",
} as const;